module.exports = __webpack_public_path__ + "assets/img/soft15.9f334e2b.jpg";